/**
 * Sidebar/MenuLink/index.tsx
 * desc: a row of the v2 sidebar that leaves the app — an external link, opened in a new tab
 * note: same row anatomy as MenuItem (icon + label; collapsed rows keep the label as tooltip + accessible name);
 *       the href is resolved at render time because it depends on the tenant's hostname
 */

import Tooltip from '../../Tooltip/typed';
import { trackEvent } from '../../../utilities/analytics';
import { translate } from '../../../utilities/localization';
import type { NavExternalLink } from '../config';
import { COLLAPSED_TOOLTIP_OFFSET } from '../constants';

interface MenuLinkProps {
    link: NavExternalLink;
    isCollapsed: boolean;
}

const MenuLink = ({ link, isCollapsed }: MenuLinkProps) => {
    //*************************************************
    //*****   Data   **********************************
    //*************************************************
    const label = translate(link.labelKey);
    const Icon = link.icon;


    //*************************************************
    //*****   Public Functions   **********************
    //*************************************************
    const handleClick = () => trackEvent(`Global: Sidebar - ${link.id} Link (Click)`);


    //*************************************************
    //*****   Render   ********************************
    //*************************************************
    return (
        <Tooltip arrow={ false } asChild side="right" sideOffset={ COLLAPSED_TOOLTIP_OFFSET } text={ isCollapsed ? label : null }>
            <a
                className="row"
                href={ link.getHref() }
                rel="noreferrer"
                target="_blank"
                aria-label={ isCollapsed ? label : undefined }
                onClick={ handleClick }
            >
                <Icon readOnly tooltip={ null }/>
                { !isCollapsed ? <span className="label">{ label }</span> : null }
            </a>
        </Tooltip>
    );
};

export default MenuLink;
